const messages = {
    "Source type" :"نوع انتشارات",
    "Keyword" :"کلیدواژه ها",
    "Document type" :"",
    "Subject area" :"",
    "Open access" :"",
    "Source title" :"",
    "affiliation.info.branch2":"تیپ دانشگاه",
    "affiliation.info.branch3":"دانشکده یا پژوهشکده",
    "affiliation.info.branch4":"گروه های آموزشی و پژوهشی",
};

export default messages
